import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { lookbookImages } from "@/lib/translations";
import Reveal from "@/components/Reveal";

export default function Lookbook() {
  const { lang, t } = useLang();

  return (
    <div data-testid="lookbook-page" className="bg-maly-cream">
      {/* Hero */}
      <section className="pt-40 lg:pt-48 pb-20 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto text-center">
          <Reveal>
            <div className="font-body text-[11px] tracking-[0.3em] uppercase text-maly-navy/60 mb-8">
              {t.lookbook.overline}
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-[-0.02em] leading-[1.02]">
              {t.lookbook.headline}
            </h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-serif italic text-lg lg:text-xl opacity-70 mt-8 max-w-2xl mx-auto leading-relaxed">{t.lookbook.sub}</p>
          </Reveal>
        </div>
      </section>

      {/* Editorial grid — asymmetric */}
      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1500px] mx-auto space-y-6 lg:space-y-10">
          {/* Row 1 */}
          <div className="grid grid-cols-12 gap-6 lg:gap-10">
            <Reveal className="col-span-12 lg:col-span-7 aspect-[4/5] img-zoom bg-maly-creamDeep">
              <img src={lookbookImages[0].src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </Reveal>
            <div className="col-span-12 lg:col-span-5 flex flex-col gap-6 lg:gap-10">
              <Reveal delay={150} className="aspect-[4/5] img-zoom bg-maly-creamDeep flex-1">
                <img src={lookbookImages[1].src} alt="" className="w-full h-full object-cover" loading="lazy" />
              </Reveal>
              <Reveal delay={250} className="hidden lg:flex items-end pb-4">
                <div>
                  <div className="font-body text-[11px] tracking-[0.3em] uppercase text-maly-navy/60 mb-2">{lookbookImages[0].caption[lang]}</div>
                  <p className="font-serif italic text-lg opacity-70">"She doesn't dress for the gallery. She dresses for herself."</p>
                </div>
              </Reveal>
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-12 gap-6 lg:gap-10">
            <Reveal className="col-span-12 lg:col-span-4 lg:mt-32 aspect-[3/4] img-zoom bg-maly-creamDeep">
              <img src={lookbookImages[2].src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </Reveal>
            <Reveal delay={200} className="col-span-12 lg:col-span-8 aspect-[16/10] img-zoom bg-maly-creamDeep">
              <img src={lookbookImages[3].src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </Reveal>
          </div>

          {/* Quote block */}
          <Reveal className="py-20 lg:py-32 text-center max-w-3xl mx-auto">
            <div className="divider-luxe mb-10">
              <span className="font-body text-[10px] tracking-[0.4em] uppercase">{lang === "en" ? "Editorial" : "Editorial"}</span>
            </div>
            <p className="font-display text-3xl lg:text-5xl font-light italic leading-[1.15] tracking-[-0.01em]">
              {lang === "en"
                ? "“Performance shouldn’t cost her presence. We refused to choose.”"
                : "„Performance darf nicht ihre Präsenz kosten. Wir haben uns geweigert zu wählen.“"}
            </p>
          </Reveal>

          {/* Row 3 */}
          <div className="grid grid-cols-12 gap-6 lg:gap-10">
            <Reveal className="col-span-12 lg:col-span-6 aspect-[4/5] img-zoom bg-maly-creamDeep">
              <img src={lookbookImages[4].src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </Reveal>
            <Reveal delay={150} className="col-span-12 lg:col-span-6 lg:mt-24 aspect-[4/5] img-zoom bg-maly-creamDeep">
              <img src={lookbookImages[5].src} alt="" className="w-full h-full object-cover" loading="lazy" />
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
